module.exports = __webpack_public_path__ + "483fded4c689cc08229314a364753170.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-19.png
// module id = 2698
// module chunks = 0